import { useEffect, useState } from 'react';
import ContentstackLivePreview from '@contentstack/live-preview-utils';
import { addEditableTags } from '@contentstack/utils';
import { ContentstackGatsby } from 'gatsby-source-contentstack/live-preview';
import { getCSData } from '../live-preview';

/**
 * useLivePreview - This hook is used to fetch the live preview data for the node.
 * @param {*} node - page data to render in live preview (ex: props.data.contentstackSAPaidLanding)
 * @param {*} content_type - content type of the page (ex: 'sa_paid_landing')
 * @returns - live preview data with editable tags
 */
export const useLivePreview = (node, content_type) => {
	const [livePreviewData, setLivePreviewData] = useState(node);

	useEffect(() => {
		const fetchLivePreviewData = async () => {
			const updatedData = await getCSData.get(node);
			ContentstackGatsby.addContentTypeUidFromTypename(updatedData);
			if (window.top !== window.self) addEditableTags(updatedData, content_type, true, 'en-us');
			setLivePreviewData(updatedData);
		};

		ContentstackLivePreview.onEntryChange(fetchLivePreviewData);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- This effect should only run once
	}, []);

	return livePreviewData;
};
